import React, { useState } from "react";
import { Card, CardBody, Col, Container, CardHeader, Row } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";
import ExportCSVModal from "../../Components/Common/ExportCSVModal";
import { useProfile } from "../../Components/Hooks/UserHooks";
import InvoicesOverdueTable from "./InvoicesOverdueTable";
import AppBreadcrumb from "../../Components/Common/AppBreadcrumb";

const InvoiceManegement = () => {
  const { userProfile, isAdmin, isEditor } = useProfile();

  const [isExportCSV, setIsExportCSV] = useState(false);

  return (
      <React.Fragment>
        <div className="page-content">
          <ExportCSVModal
              show={isExportCSV}
              onCloseClick={() => setIsExportCSV(false)}
              data={"null"}
          />

          <Container fluid>
            <AppBreadcrumb />
            <Row>
              <Col lg={12}>
                <Card id="orderList">
                  <CardHeader className="border-0">
                    <Row className="align-items-center gy-3">
                      <div className="col-sm">
                        <h5 className="card-title mb-0">Invoice Email Management</h5>
                      </div>
                      <div
                          className="col-sm-auto"
                          style={{ marginBottom: "10px" }}
                      >
                        <div className="d-flex gap-1 flex-wrap">
                          <button
                              type="button"
                              className="btn btn-info"
                              onClick={() => setIsExportCSV(true)}
                          >
                            <i className="ri-file-download-line align-bottom me-1"></i>{" "}
                            Export
                          </button>
                        </div>
                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody className="pt-0">
                    <InvoicesOverdueTable />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
  );
};

export default InvoiceManegement;
